var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters__value-rating"},[_c('Rating',{attrs:{"rating-style":_vm.field.style,"color":_vm.field.color,"value":_vm.copy,"max-value":_vm.field.max_value},on:{"update":function($event){return _vm.delayedUpdate($event, true)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }